import React from 'react';
import SVG from 'react-inlinesvg';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled(SVG)`
    ${({ height, width }) => `
        svg {
            height: ${height ? `${height}px` : 'auto'};
            width: ${width ? `${width}px` : 'auto'};
        }
    `};
`;

class SvgComponent extends React.Component {
    render() {
        return <Wrapper {...this.props} cacheRequests />;
    }
}

SvgComponent.propTypes = {
    src: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default SvgComponent;



// WEBPACK FOOTER //
// ./src/components/SvgComponent.js